import { render, staticRenderFns } from "./MonsterArchive.vue?vue&type=template&id=5f9a8f81"
import script from "./MonsterArchive.vue?vue&type=script&lang=js"
export * from "./MonsterArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9a8f81')) {
      api.createRecord('5f9a8f81', component.options)
    } else {
      api.reload('5f9a8f81', component.options)
    }
    module.hot.accept("./MonsterArchive.vue?vue&type=template&id=5f9a8f81", function () {
      api.rerender('5f9a8f81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monster/MonsterArchive.vue"
export default component.exports